var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaveLogoSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5836 19.2488C32.5836 19.2447 32.5794 19.2405 32.5794 19.2364C32.5711 19.2156 32.5669 19.199 32.5669 19.199C32.1733 18.1119 31.5536 17.1243 30.6995 16.2405C29.1168 14.5973 27.0735 13.7757 24.5738 13.7757H13.1683V39.5312H17.0287V17.2322H24.3435C25.9011 17.2322 27.1279 17.6928 28.0197 18.6139C28.7022 19.3194 29.1209 20.1783 29.2801 21.1949L29.3345 21.7634L29.3387 21.7592L32.726 19.7218L32.7386 19.7135C32.6716 19.5019 32.6088 19.3277 32.5836 19.2488Z",
    fill: "#6730A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8196 0C36.1385 18.0085 19.6122 31.353 0 31.353V35.0875C21.7015 35.0875 39.9319 20.0873 44.6968 0H40.8196Z",
    fill: "#6730A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaveLogoSimple);
export default __webpack_public_path__ + "static/media/pave-logo-simple.ba30fc74de66c3c4133712706af8522d.svg";
export { ForwardRef as ReactComponent };